import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationsEn from 'locales/en.json';
import translationsEs from 'locales/es.json';
import translationsFr from 'locales/fr.json';

const resources = {
  en: {
    translation: translationsEn,
  },
  es: {
    translation: translationsEs,
  },
  fr: {
    translation: translationsFr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
